<div class="login">
    <div class="side-image"></div>
    <div class="login-form" [ngSwitch]="mode">
  
        <form [formGroup]="Form" (ngSubmit)="Submit($event)" *ngSwitchCase="'pass'">
          <div class="title">Change Password</div>
          <div class="form">
            <div class="input">
              <mat-form-field class="example-full-width">
                <mat-label>Current Password</mat-label>
                <input
                  formControlName="Current_Password"
                  type="password"
                  matInput
                  placeholder="***********"
                />
              </mat-form-field>
            </div>
            <div class="input">
              <mat-form-field class="example-full-width">
                <mat-label>New Password</mat-label>
                <input
                  formControlName="New_Password"
                  type="password"
                  matInput
                  placeholder="***********"
                />
              </mat-form-field>
            </div>
          </div>
          <div class="errorMessage">
            <div *ngIf="loginErrors" class="error">
              <p>{{ loginErrors }}</p>
            </div>
          </div>
          <div class="butto" style="margin-bottom: 20px;">
            <button class=" btn btn-primary btn-block" color="">
              {{ isLoading ? "Changing" : "Change" }}
            </button>
          </div>
          <a
          [routerLink]="['/']"
          class="pss"
          >
            Home
          </a>

        </form>
    </div>
  </div>
  